module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic-ext53.47734ae.woff2";